export default {
  data() {
    return {
      focusElement: false,
    };
  },

  methods: {
    focusElementHandler() {
      this.focusElement = true;
    },

    blurElementHandler() {
      this.focusElement = false;
    },

    isFocusElement() {
      if (this.focusElement) {
        this.focusElement = false;
        return true;
      }
      return false;
    },
  },
};
